import { TimechiefClient } from '../timechiefclient';
import { VersionProduct, VersionStream } from '../../env';

class DownloadService {
    async listVersions() {
        return TimechiefClient.default.listLatestVersions(VersionProduct, VersionStream);
    }

    async downloadVersion(uuid) {
        return TimechiefClient.default.getVersionDownloadById(uuid);
    }
}

export const Service = new DownloadService();